import styled, { css, keyframes } from 'styled-components';

export const HistoryList = styled.ul`
  ${({ theme, $hasScroll, $fullScreen }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    margin: 0px;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: ${$fullScreen ? '20px' : '0px'};


    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
      border-radius: 40px;
      outline: ${theme.v2.colors.neutral.highMedium} solid 1px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highLight};
      border-radius: 40px;
      border: 2px solid ${theme.v2.colors.neutral.highPure};
      cursor: pointer;
      width: calc(100% - 4px);
    }

    ${$hasScroll && css`
      padding-right: 16px;
    `}
  `}
`;

export const ListItem = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ResponseText = styled.span`
  ${({ theme, $src }) => css`
    background-color: ${$src === 'client' ? theme.v2.colors.neutral.highLight : 'transparent'};
    border-radius: ${$src === 'client' ? '20px 20px 0px 20px' : '20px 20px 20px 0px'};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin-left: ${$src === 'client' ? 'auto' : 'unset'};
    max-width: calc(100% - 40px);
    padding: ${$src === 'client' ? '16px' : '0px'};
    width: fit-content;

     > * {
      margin: 0px;
      padding: 0px;
     }

     a {
      color: ${theme.v2.colors.brand.primaryMedium};
      cursor: pointer;

      &:hover {
        color: ${theme.v2.colors.brand.primaryDark};
      }
     }
  `}
`;

export const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0px;
  padding: 0px;
  width: 100%;
`;

export const OptionItem = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
`;


export const HistoryRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
`;

export const HistoryColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: calc(100% - 40px);
`;

export const MaiaIcon = styled.img`
  ${({ theme }) => css`
    border-radius: 50%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    height: 32px;
    margin: '-2px 0px 0px 0px';
    width: 32px;
  `}
`;

const backgroundAnimation = () => keyframes`
  0% { background-position: 100%; }
  50% { background-position: 50%; }
  100% { background-position: 0%; }
`;

export const LoadingMessage = styled.span`
  ${() => css`
      animation: ${backgroundAnimation} 3s infinite linear;
      background: linear-gradient(90deg, #0070D1, #1F2044, #0070D1);
      background-clip: text;
      background-size: 200% 100%;
      color: transparent;
      padding: 5px 0px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
  `}
`;

export const ButtonOption = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    letter-spacing: -0.154px;
    max-width: 320px;
    padding: 16px;
    text-align: left;
    transition: 200ms ease-in-out;
    width: 100%;

    &:hover {
      border: 1px solid ${theme.v2.colors.brand.primaryMedium};
      background-color: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
      color: ${theme.v2.colors.brand.primaryMedium};
    }

    &:disabled {
      background-color: ${theme.v2.colors.neutral.highLight} !important;
      border: 1px solid ${theme.v2.colors.neutral.highLight} !important;
      color: ${theme.v2.colors.neutral.lowDark} !important;
      cursor: not-allowed !important;
    }
  `}
`;

export const RatingRow = styled.div`
  display: flex;
  flex-direction: row;
  gap:4px;
  margin: 0px;
  min-width: 100%;
`;

export const RoundedButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 0px;
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: center;
    transition: background-color 250ms ease-in-out;
    width: 24px;

    &:hover {
      background-color: ${theme.v2.colors.neutral.highLight};
    }
  `}
`;
export const ResponseImage = styled(ResponseText)`
    cursor: pointer;
    display: row;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
`;


export const Image = styled.img`
  ${({ $full }) => css`
    border-radius: 16px;
    box-sizing: border-box;
    max-width: 70vw;
    width: ${$full ? 'auto' : '100%'};
  `}
`;

export const ImageWrapper = styled.button`
  background-color: transparent;
  border: 0px;
  border: 16px;
  cursor: pointer;
  overflow: hidden;
  position: relative;

  &:hover > div {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  align-items: center;
  background-color: rgba(10, 10, 10, 0.4);
  border-radius: 16px;
  color: white;
  display: flex;
  font-size: 1.5rem;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity 250ms ease;
  width: 100%;
`;

export const OverlayText = styled.span`
    ${({ theme }) => css`
      align-items: center;
      color:${theme.v2.colors.neutral.highPure};
      display: flex;
      flex-direction: row;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      gap: 16px;
      justify-content: center;
    `}
`;

export const DocumentMsgWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highExtraLight};
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    height: 64px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    width: 100%;
    max-width: 400px;
  `}
`;

export const DocumentTitle = styled.span`
  ${({ theme }) => css`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${theme.v2.colors.neutral.lowDark};
  font-family: ${theme.v2.font.family.primary};
  font-size: ${theme.v2.font.sizes.xs};
  font-weight: ${theme.v2.font.weights.medium};
  `}
  `;

export const DocumentTitleText = styled.span``;

export const DocumentActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  `;

export const DocumentDownload = styled.a`
  cursor: pointer;
`;

export const SnippetWrapper = styled.div`
  ${({ theme }) => css`
    > button {
      padding: 3px !important;
    }

    span {
      display: none;
    }

    path {
      stroke: ${theme.v2.colors.neutral.lowMedium};
    }

    &:hover {
      path {
      stroke: ${theme.v2.colors.brand.primaryExtraDark};
      }
    }
  `}
`;

export const NameRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;
    min-width: 100%;
`;

export const AiName = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;
